module.exports = __webpack_public_path__ + "img/undTooth7.cff61e04.png";